import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useTranslation from '../../hooks/useTranslations';
import { selectFolderById } from '../../redux/modules/data/foldersSlice';
import { selectNewsById } from '../../redux/modules/data/newsSlice';
import { selectEvaluationById } from '../../redux/modules/evaluationsSlice';
import { selectFavoriteListByIdWithObjects, selectIPadFavoriteListById } from '../../redux/modules/favoritesSlice';

export const setDocumentTitle = (titleSegments) => {
	const title = titleSegments.filter(Boolean).join(' - ');
	const mainTitle = process.env.REACT_APP_SITE_TITLE;
	document.title = `${title}${title && ' - '}${mainTitle}`;
};

const SetDocumentTitleNews = () => {
	const t = useTranslation();
	const { newsId } = useParams();
	const news = useSelector((state) => selectNewsById(state, newsId));
	if (news) {
		setDocumentTitle([t('news_button'), news.title]);
	}
	return null;
};

const SetDocumentTitleFavoriteList = () => {
	const t = useTranslation();
	const { favoriteListId } = useParams();
	const favoriteList = useSelector((state) => selectFavoriteListByIdWithObjects(state, favoriteListId));
	const iPadFavoriteList = useSelector((state) => selectIPadFavoriteListById(state, favoriteListId));

	if (favoriteList || iPadFavoriteList) {
		setDocumentTitle([t('tab_favorite_lists'), favoriteList?.title ?? iPadFavoriteList.title]);
	}

	return null;
};

const SetDocumentTiteEvaluation = () => {
	const t = useTranslation();
	const { id } = useParams();

	// New
	const evaluationCategory = useSelector((state) => selectFolderById(state, id));
	// Edit
	const evaluation = useSelector((state) => selectEvaluationById(state, id));

	if (evaluationCategory) {
		setDocumentTitle([t('eval_app_evaluations'), t(evaluationCategory.translationkey)]);
	} else if (evaluation) {
		setDocumentTitle([t('eval_app_evaluations'), evaluation.title]);
	}
	return null;
};

const SetDocumentTitleStatic = ({ type }) => {
	const t = useTranslation();

	switch (type) {
	case 'home':
		setDocumentTitle([t('tab_main')]);
		break;
	case 'login':
		setDocumentTitle([t('login_login_button')]);
		break;
	case 'register':
		setDocumentTitle([t('register_register_button')]);
		break;
	case 'forgot-password':
		setDocumentTitle([t('webapp_forgot_activationkey')]);
		break;
	case 'loading':
		setDocumentTitle([t('general_loading')]);
		break;
	case 'newsList':
		setDocumentTitle([t('news_button')]);
		break;
	case 'recentlyViewed':
		setDocumentTitle([t('dashboard_recently_used_button')]);
		break;
	case 'favorites':
		setDocumentTitle([t('tab_favorite_lists')]);
		break;
	case 'evaluations':
		setDocumentTitle([t('eval_app_evaluations')]);
		break;
	default:
		setDocumentTitle([]);
		break;
	}
	return null;
};

const SetDocumentTitle = ({ type }) => {
	if (type === 'newsDetail') {
		return <SetDocumentTitleNews />;
	}
	if (type === 'favoriteList') {
		return <SetDocumentTitleFavoriteList />;
	}
	if (type === 'evaluationForm') {
		return <SetDocumentTiteEvaluation />;
	}
	return <SetDocumentTitleStatic type={type} />;
};

export default memo(SetDocumentTitle);
